
import { toRefs, reactive, ref, computed, onMounted, watchEffect } from "vue";
import Title from "@/components/Title.vue";
import HeadTitle from "@/components/HeadTitle.vue";
import { CaretDownOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import Approval from "@/components/Approval.vue";
import OpenButtonGroup from "@/components/OpenButtonGroup.vue";
import ApplyInfoCard from "@/components/ApplyInfoCard.vue";
import moment from "moment";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import {
  getOpenEditDetail,
  handleOpenApprove,
  handleOpendraw,
  handleGoOrReject,
  handleSet,
} from "@/api/openapply";
/* eslint-disable */
export default {
  name: "Open",
  components: {
    HeadTitle,
    Title,
    ApplyInfoCard,
    CaretDownOutlined,
    Approval,
    OpenButtonGroup,
  },

  setup(props: any, context: any) {
    const refresh = ref<boolean>(false);
    const WorkFlowId = ref<number>(0);
    const Spinning = ref(true);
    const route = useRoute();
    const FormRef = ref();
    const store = useStore();
    const personInfo = computed(() => store.getters.getSimpleInfo);
    const edit = computed(
      () =>
        data.ActionButtons?.includes("100") ||
        data.ActionButtons?.includes("102")
    );
    const editStatus = computed(() => data.ActionButtons?.includes("100"));
    type matterItem = { label: string; value: any };
    const data = reactive<{
      [key: string]: any;
      OpenMatters: matterItem[][];
    }>({
      Spinning: false, // 整个页面loading
      CompanyTypeList: [], // 公司类型列表
      CitysList: [], // 城市列表
      spinning: false, // 申请审批loading
      isEditApply: true,
      rejectedVisible: false,
      recallVisible: false,
      rejectResume: "", // 驳回
      recallResume: "", // 撤回
      id: props?.id,
      OpenMatters: [[{ label: "", value: "" }]],
      ActionButtons: [], // 流程按钮
      ExpectOpenTime: "", // 预计开业时间
      ApplicationTime: "", // 申请时间
      ApplicationInfo: {},
    });
    // 表单字段定义
    const FormData = reactive({
      ID: 0,
      Type: "", // 公司类型值
      TypeName: "" || undefined, // 公司类型名称
      CityId: "", // 城市
      CityName: "",
      ExpectOpenTime: "", // 预计开业时间
      ActionType: 0, // 按钮类型
    });
    // 选定城市
    const citysChange = (val: any, option: any) => {
      FormData.CityId = val && val[val.length - 1];
      if (option.length > 1) {
        let Text = option
          .map((item: any) => {
            return item.Text;
          })
          .join("");
        FormData.CityName = Text;
      } else {
        FormData.CityName = option[option.length - 1].Text;
      }
    };
    const displayRender = (val: any) => {
      return val.labels[val.labels.length - 1];
    };
    // 公司类型
    const CompanyTypeListChange = (val: any) => {
      FormData.Type = val;
      data.CompanyTypeList.forEach((item: any) => {
        if (item.Val == val) {
          FormData.TypeName = item.Key;
        }
      });
    };

    // 预计开业时间改变
    const handleOpenChange = (dateString: string) => {
      FormData.ExpectOpenTime = dateString;
    };
    const disabledDate = (current: any) => {
      return current && current < Date.now() - 8.64e7;
    };

    // 驳回弹窗
    const submitRejectApply = () => {
      handleStatus(FormData.ID, 2, data.rejectResume);
    };
    // 取消驳回
    const handleCancelRejectApply = () => {
      data.rejectedVisible = false;
      data.rejectResume = "";
    };
    // 撤回提交

    const submitRecallApply = async () => {
      if (!data.recallResume) {
        message.error("请输入撤回理由");
        return;
      }
      handleBack(FormData.ID, data.recallResume);
    };
    // 取消撤回
    const handleCancelRecallApply = () => {
      data.recallVisible = false;
      data.recallResume = "";
    };
    // 申请审批提交
    const submitData = (actionButtonsType: string) => {
      if (actionButtonsType === "100") {
        handleApprove(); // 调用审批方法
      } else if (actionButtonsType === "101") {
        // 撤回
        data.recallVisible = true;
      } else if (actionButtonsType === "103") {
        // 通过
        handleStatus(FormData.ID, 1);
      } else if (actionButtonsType === "104") {
        // 驳回
        data.rejectedVisible = true;
      } else {
        // 重新发起
        handleReissue();
      }
    };
    // 开业审批
    const handleApprove = async () => {
      FormRef.value.validate().then(async () => {
        Spinning.value = true;
        //提交申请
        const { Data, Success, Message } = await handleOpenApprove({
          Id: FormData.ID,
          Type: FormData.Type,
          CityId: FormData.CityId,
          ExpectOpenTime: FormData.ExpectOpenTime,
          TypeName: FormData.TypeName,
          CityName: FormData.CityName,
        });
        if (Success) {
          Spinning.value = false;
          FormData.ID = Data;
          data.ExpectOpenTime = Data?.ExpectOpenTime;
          getOpenEditInfo(FormData.ID, 1);
        } else {
          message.warning(Message);
        }
      });
    };
    //重新发起
    const handleReissue = () => {
      getOpenEditInfo(FormData.ID, 2, true);
    };
    // 撤回方法
    const handleBack = async (Id: number, Description: string) => {
      Spinning.value = true;
      const { Data, Success, Message } = await handleOpendraw({
        Id,
        Description,
      });
      if (Success) {
        Spinning.value = false;
        data.recallVisible = false;
        message.warning(Message || "撤回成功");
        handleCancelRecallApply();
        getOpenEditInfo(FormData.ID, 1);
        refresh.value = !refresh.value;
      } else {
        message.warning(Message || "撤回失败");
      }
    };
    // 通过、驳回
    const handleStatus = async (
      Id: number,
      Status: number,
      Description?: string
    ) => {
      Spinning.value = true;
      const { Data, Success, Message } = await handleGoOrReject({
        Id,
        Status,
        Description,
      });
      if (Success) {
        Spinning.value = false;
      } else {
        message.warning(Message);
      }
    };
    // 获取开业申请详情
    const getOpenEditInfo = async (
      Id: number,
      ActionType: number,
      flag?: boolean
    ) => {
      Spinning.value = true;
      const { Data, Success, Message } = await getOpenEditDetail({
        Id,
        ActionType: ActionType ? ActionType : 1,
      });
      if (Success) {
        Spinning.value = false;
        WorkFlowId.value = Data?.WorkFlowId || 0;
        data.ApplicationInfo = Data.ApplicationInfo;
        data.ApplicationTime = Data.ApplicationTime;
        data.CompanyTypeList = Data.CompanyType;
        data.CitysList = Data.Citys;
        FormData.ExpectOpenTime = Data.ExpectOpenTime || "";
        FormData.CityId = Data.CityId || "";
        FormData.CityName = Data.CityName || "";
        if (Data.Type == 0) {
          FormData.TypeName = undefined;
        } else {
          FormData.Type = Data.Type;
          data.CompanyTypeList.forEach((item: any, index: number) => {
            if (item.Val == Data.Type) {
              FormData.TypeName = data.CompanyTypeList[index].Key;
            }
          });
        }
        data.ActionButtons = Data.ActionButtons;
        if (flag) {
          data.ActionButtons.unshift("90");
        }
        FormData.ActionType = Data.ActionType || "";
        if (edit) {
          data.OpenMatters = [
            [
              { label: "公司类型", value: Data.TypeName },
              {
                label: "对接会计",
                value: Data.DockingAccountingName
                  ? Data.DockingAccountingName
                  : "(待集团财务部门设置)",
              },
            ],
            [
              { label: "选定城市", value: Data.CityName },
              {
                label: "对接出纳",
                value: Data.DockingCashierName
                  ? Data.DockingCashierName
                  : "(待集团财务部门设置)",
              },
            ],
            [{ label: "预计开业时间", value: Data.ExpectOpenTime }],
          ];
        }
        FormData.ID = Data.ID;
      }
    };
    watchEffect(() => {
      const { id } = route.query;
      id && getOpenEditInfo(Number(id), Number(route.query.ActionType));
      if (personInfo.value.IsCreate == 0 && id) {
        //审批人
        if (!data.ActionButtons.includes("90")) {
          //审批人增加返回按钮
          data.ActionButtons.value.unshift("90");
        }
      }
    });
    onMounted(async () => {
      getOpenEditInfo(0, 1);
    });
    return {
      ...toRefs(data),
      submitData,
      FormRef,
      FormData,
      edit,
      editStatus,
      Spinning,
      WorkFlowId,
      refresh,
      handleOpenChange,
      disabledDate,
      getOpenEditDetail,
      submitRejectApply,
      submitRecallApply,
      handleCancelRecallApply,
      handleCancelRejectApply,
      displayRender,
      handleSet,
      citysChange,
      CompanyTypeListChange,
    };
  },
};
